import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png"
import Linkedin from "@iconscout/react-unicons/icons/uil-linkedin";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Github from "@iconscout/react-unicons/icons/uil-github";

export const Footer = () => {
    return(
        <div className="footer">
            <img src={Wave} alt="" style={{width: '100%'}} />
            <div className="f-content">
                <span>davidsvce@gmail.com</span>
                <div className="f-icons">
                    <Linkedin color="white" size="3rem" />
                    <Facebook color="white" size="3rem" />
                    <Github color="white" size="3rem" />
                </div>
            </div>
        </div>
    );
}